import React, { useState } from 'react';
import { Box, ChevronDownIcon, ChevronUpIcon, Inscription } from '@common-fe/common-fe';

import { useOrganizationProperties } from '@/modules/transaction/hooks';
import theme from '@/styles/theme';

const Informant = () => {
  const { organizationProperties } = useOrganizationProperties();
  const [isShown, setIsShown] = useState(true);

  return (
    <Box>
      <Box direction="row" align="center" height="40px" onClick={() => setIsShown(!isShown)}>
        <Box margin={{ right: 'spacing12' }}>
          {isShown ? <ChevronUpIcon size="24px" color="iconPrimary" /> : <ChevronDownIcon size="24px" color="iconPrimary" />}
        </Box>
        <Inscription color="textBody" weight="bold" lineHeight="22px" size="16px">I am unable to repay using my bank account</Inscription>
      </Box>

      {isShown ? (
        <Box>
          <Box>
            <Inscription color="textBody" lineHeight="20px">
              You can also repay this claim by mailing a check.
              <Box pad={{ top: 'spacing12' }} margin={{ left: 'spacing16' }}>
                <ol style={{ listStyle: 'auto', marginLeft: theme.spacings.spacing16 }}>
                  <li>Make the check payable to <Inscription weight="bold">{organizationProperties?.partnerName}</Inscription>.</li>
                  <li>Include the claim number that you are repaying in the Memo field on the check. <Inscription weight="bold">If there are multiple claims, please be sure to include each claim number.</Inscription></li>
                  <li>Send checks to:</li>
                </ol>
              </Box>
            </Inscription>
          </Box>
          <Box
            round="small"
            background="infoContainer"
            pad={{ horizontal: 'spacing24', bottom: 'spacing24' }}
            style={{ outline: `1px solid ${theme.colors.infoBorder}` }}
            margin={{ vertical: 'spacing12' }}
          >
            <Box
              border={{ color: 'info', size: 'large', side: 'top' }}
              pad={{ top: '22px' }}
            >
              <Inscription color="textBody" weight="bold" lineHeight="20px">
                {organizationProperties?.partnerName}<br />
                PO BOX 875050<br />
                KANSAS CITY, MO 64187-5050<br />
              </Inscription>
            </Box>
          </Box>
          <Inscription color="textSecondary" lineHeight="20px">
            Repayments may take 7-10 business days from the mailing date to reflect in your account.
          </Inscription>
        </Box>
      ) : null}
    </Box>
  );
};

export default Informant;
